	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.Base.EEObject;


//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs/ref/Base/EEObject.js
// module id = 116
// module chunks = 0